import {
  PDFTextHighlightAnnotation,
  TextHighlightAnnotation,
} from '@readcloud/data';

import * as React from 'react';

import { AnnotationPopover } from './AnnotationPopover/AnnotationPopover';
interface IConnectedAnnotitionPopoverProps {
  selectedAnnotation: PDFTextHighlightAnnotation | TextHighlightAnnotation;
  container?: HTMLElement;
  boundsElement?: HTMLElement;
  positionFixed?: boolean;
  deselectAnnotation?: () => void;
}

export const ConnectedAnnotationPopover: React.FunctionComponent<
  IConnectedAnnotitionPopoverProps
> = (props) => {
  return (
    <AnnotationPopover
      boundsElement={props.boundsElement}
      container={props.container}
      selectedAnnotation={props.selectedAnnotation}
      positionFixed={props.positionFixed}
      deselectAnnotation={props.deselectAnnotation}
    />
  );
};
